import React, { useEffect, useRef, useState } from "react";
import "./CustomerReviews.css";
import { FaUserCircle } from "react-icons/fa";

const reviews = [
  {
    name: "RAJAT MEHTA",
    // role: "Local Guide·12 reviews·1 photo",
    // time: "5 years ago",
    content:
      "A real professional setup and customer focussed mindset. We received excellent support even for the services not part of original agreement.",
    rating: 5,
  },
  {
    name: "Satya Prakash Gupta",
    // role: "Local Guide·165 reviews·207 photos",
    // time: "4 years ago",
    content:
      "They deliver the best possible work and experience at optimal value. I definitely would recommend them.",
    rating: 5,
  },
  {
    name: "Vipul Marwaha",
    // role: "7 reviews",
    // time: "4 years ago",
    content:
      "Highly professional organisation which offers optimum services at competitive price.",
    rating: 5,
  },
  {
    name: "Dipanshu Vijay",
    // role: "10 reviews",
    // time: "5 years ago",
    content:
      "Very happy and content with their quality, responsiveness and timeliness.",
    rating: 5,
  },
];

// STAR COMPONENT (unchanged)
const ReviewStars = ({ rating }) => {
  const stars = [];
  for (let i = 0; i < 5; i++) {
    stars.push(
      <span key={i} className={i < rating ? "cr-star active" : "cr-star"}>
        ★
      </span>
    );
  }
  return <div className="cr-stars">{stars}</div>;
};

const CustomerReviews = () => {
  const sliderRef = useRef(null);
  const [scrollAmount, setScrollAmount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!sliderRef.current) return;

      const maxScroll =
        sliderRef.current.scrollWidth - sliderRef.current.clientWidth;

      if (scrollAmount >= maxScroll) {
        setScrollAmount(0);
        sliderRef.current.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        const next = scrollAmount + 300;
        setScrollAmount(next);
        sliderRef.current.scrollTo({ left: next, behavior: "smooth" });
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [scrollAmount]);

  const moveLeft = () => {
    sliderRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const moveRight = () => {
    sliderRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <section className="cr-section">
      <h2 className="cr-title">Testimonials</h2>

      <div className="cr-slider-wrapper">
        <button className="cr-btn left" onClick={moveLeft}>
          &#10094;
        </button>

        <div className="cr-slider" ref={sliderRef}>
          {reviews.map((item, index) => (
            <div className="cr-card" key={index}>
              <div className="cr-header">
                {/* USER ICON */}
                <FaUserCircle className="cr-user-icon" />

                <h3>{item.name}</h3>
                <span className="cr-role">{item.role}</span>
                <span className="cr-time">{item.time}</span>
                <ReviewStars rating={item.rating} />
              </div>

              <p className="cr-text">{item.content}</p>
            </div>
          ))}
        </div>

        <button className="cr-btn right" onClick={moveRight}>
          &#10095;
        </button>
      </div>
    </section>
  );
};

export default CustomerReviews;
